import {format} from "date-fns";

export function fmtDateTimeISO(iso?: string | null) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "—";
    return <time dateTime={iso}>{format(d, "MMM d, yyyy HH:mm")}</time>;
}
